var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"bc-my-projects-section-header",style:({ paddingBottom: _vm.paddingBottom })},[_c('div',{staticClass:"icon-headline"},[_c(_setup.icons[_vm.icon],{tag:"component"}),_c('h2',[_vm._v(_vm._s(_vm.title))]),_vm._t("headline")],2),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }